import axios from 'axios'
import showToastify from '../utils/toastify'
import 'toastify-js/src/toastify.css'
import { find } from 'utils/dom'

export default function contatoForm() {
	const page = find("[js-page='contato']");
	if (!page) return;

	const btnSubmit = document.querySelector('.contact-form-1 button[type=submit]');
	const contatoFormSubmit = document.querySelector('.contact-form-1');

	function disabledBtn() {
		btnSubmit.disabled = true;
		btnSubmit.classList.add('disabled');
	}

	function enabledBtn() {
		btnSubmit.disabled = false;
		btnSubmit.classList.remove('disabled');
	}

	function showMessage(response) {
		const message = response.data ? response.data.message : response.message;
		showToastify(message);
		contatoFormSubmit.reset();
		setTimeout(enabledBtn, 1000);
	}

	if (contatoFormSubmit) {
		contatoFormSubmit.addEventListener('submit', async function (event) {
			event.preventDefault();
			disabledBtn();

			const nome = document.querySelector('.contact-form-1 .form-group input[name=nome]').value;
			const email = document.querySelector('.contact-form-1 .form-group input[name=email]').value;
			const telefone = document.querySelector('.contact-form-1 .form-group input[name=telefone]').value;
			const mensagem = document.querySelector('.contact-form-1 .form-group textarea[name=mensagem]').value;

			const EmailErro = document.querySelector('.contato-email-error');
			const NomeErro = document.querySelector('.contato-nome-error');

			EmailErro.innerText = '';
			NomeErro.innerText = '';

			let Erros = 0;
			if (email === '') {
				EmailErro.innerText = 'Favor preencher os campos obrigatórios.';
				Erros++;
			}
			if (nome === '') {
				NomeErro.innerText = 'Favor preencher os campos obrigatórios.';
				Erros++;
			}
			if (Erros > 0) {
				enabledBtn();
				return;
			}

			if (!window.grecaptcha || !window.site_key) {
				console.error('reCAPTCHA não carregado ou site_key ausente.');
				enabledBtn();
				return;
			}

			try {
				const token = await grecaptcha.execute(window.site_key, { action: 'submit' });

				const formData = new FormData();
				formData.append('nome', nome);
				formData.append('email', email);
				formData.append('telefone', telefone);
				formData.append('mensagem', mensagem);
				formData.append('recaptcha_token', token);

				const url = '/fale-conosco/';

				axios
					.post(url, formData)
					.then((response) => showMessage(response))
					.catch((response) => showMessage(response));
			} catch (err) {
				console.error('Erro ao executar o reCAPTCHA:', err);
				enabledBtn();
				showToastify('Erro de segurança ao enviar. Tente novamente.');
			}
		});
	}
}
